/* eslint-disable */

import services from 'services';
import store from '@/store';
import { auth as fbAuth } from '@/vendors/firebase/firebase';

const _ = require('lodash');

export default {
  /**
   * Applied as a middleware before a root is executed.
   * @method guardRoute
   * @param  {Object}   to     the next route object
   * @param  {Object}   from   the current route object
   * @param  {Function} next   callback used by vue-router
   * @return {void}
   */
  async guardRoute(to, from, next) {
    const auth = store.getters['auth/isAuthenticated'];
    const shopAuth = await store.dispatch('$hbui/shopAuth/fetchState');
    let isAuthenticated = true;
    if (!auth) {
      isAuthenticated = services.authService.listenUserState().then((user) => {
        if (user) {
          store.dispatch('auth/loginUser', user);
          return fbAuth.currentUser.getIdToken(true).then((token) => {
            return(token);
          });
        }
        store.dispatch('auth/logout');
        return null;
      }).then((token) => !!token);
    }

    Promise.resolve(isAuthenticated).then((isAuth) => {
      // route requires auth
      console.log('isAuth', from.name, isAuth, shopAuth, to.name);
      if (_.get(to, 'meta.auth') === true && (!isAuth || !shopAuth)) {
        return next({ name: 'Login' });
      } else if (_.get(to, 'meta.shopAuth') === true && !shopAuth) {
        return next({ name: 'ShopSignIn'})
      } else if (_.get(to, 'meta.guestOnly') === true && isAuth && shopAuth) {
        return next({ name: 'Dashboard' });
      } else if (_.get(to, 'meta.guestOnly') === true && shopAuth) {
        return next({ name: 'Login' });
      }
      console.log('RETURNING NEXT()');
      return next();
    });
  },
};
